import React, { useEffect } from "react";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { makeSideBarActive } from "../../utils/EllowUtils";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from "react";
import Styles from "./styles.module.scss";
import { viewedpageMixpanel } from "../../utils/mixpanel";
import { useNavigate } from "react-router-dom";
import { viewpublicdata } from "./services";
import { useLocation } from 'react-router-dom'
function JsonResponse() {
    const menu = makeSideBarActive(CONSTANTS.sideMenu, 2);
    const BreadcrumsValues = ["View Public Data"];
    const location: any = useLocation()
    const { candidateId }: any = location.state || ''
    const [data, SetData] = useState([]);
    let value = {
        "candidate_id": candidateId
    };


    useEffect(() => {
        viewpublicdata(value).then((response: any) => {
            if (response && response.status === 1) {
                SetData(response.data)
            }
        })
        viewedpageMixpanel();
    }, []);
    const applyFilter = () => {

    };

    const searchChange = () => {

    };
    const closeTag = () => {

    }
    return (
        <section className="dashboardWrapper">
            <SideMenu menu={menu} openresource={"publicdatabase"} />
            <div className="dashboardContent">
                <DashboardHeader
                    title={BreadcrumsValues}
                    applyResourceFilter={applyFilter}
                    searchChange={searchChange}
                    closeTag={closeTag}
                    type="resources"

                />
                <section>
                    <div className={Styles.tableWrapper}>
                        <div><pre>{JSON.stringify(data, null, 2)}</pre></div>
                    </div>
                </section>

            </div>
        </section>
    );
}

export default JsonResponse;
